/**
 * Calil 統合検索 API サービス
 *
 * バックエンド /api/calil/* プロキシを叩く軽量ラッパー。
 */

import { apiClient } from '@/api/client'
import type {
  CalilLibraryMapping,
  CalilPollingResponse,
  CalilSearchParams,
  CalilSearchStartResponse,
} from '@/api/types/calil'

/**
 * 指定 region の図書館 ID ↔ 館名マッピングを取得
 */
export const getCalilMapping = async (region: string): Promise<CalilLibraryMapping> => {
  const res = await apiClient.get('/calil/mapping', { params: { region } })
  return res.data
}

/**
 * 検索を開始する
 * 返却の uuid / version を polling に渡す。
 */
export const startCalilSearch = async (params: CalilSearchParams): Promise<CalilSearchStartResponse> => {
  const res = await apiClient.get('/calil/search', { params })
  return res.data
}

/**
 * 検索進捗をポーリングする
 * running=false になるまで繰り返し呼び出す。
 */
export const pollCalilSearch = async (
  uuid: string,
  version: number,
  options?: { diff?: number; timeout?: number; signal?: AbortSignal },
): Promise<CalilPollingResponse> => {
  const res = await apiClient.get('/calil/polling', {
    params: {
      uuid,
      version,
      diff: options?.diff ?? 1,
      timeout: options?.timeout ?? 10,
    },
    signal: options?.signal,
  })
  return res.data
}
